import { render, staticRenderFns } from "./category_copy_4.vue?vue&type=template&id=a8c42ffe&scoped=true&"
import script from "./category_copy_4.vue?vue&type=script&lang=js&"
export * from "./category_copy_4.vue?vue&type=script&lang=js&"
import style0 from "./category_copy_4.vue?vue&type=style&index=0&id=a8c42ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c42ffe",
  null
  
)

export default component.exports